function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10",
  height: "18",
  viewBox: "0 0 10 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.334 17.949V9.527H0V6.494h2.334v-2.59C2.334 1.87 3.714 0 6.89 0c1.287 0 2.238.118 2.238.118l-.075 2.831s-.97-.009-2.029-.009c-1.145 0-1.329.504-1.329 1.34v2.214h3.45l-.15 3.033h-3.3v8.422h-3.36z",
  fill: "currentColor",
  fillRule: "evenodd"
})));